// components/MapboxIsochroneMap.js
import React, { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

mapboxgl.accessToken = 'pk.eyJ1IjoiaHVzaGlibzEyMyIsImEiOiJjbWE3ancyeDYxNnFnMmpwcGNvZHlydHlyIn0.e2n5bibB_7dLAHf5CgS09g';

const restaurantCoordinates = [-83.956007, 34.0359971]; // [lng, lat]

const MapboxIsochroneMap = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current) return;

    const map = new mapboxgl.Map({
      container: mapRef.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: restaurantCoordinates,
      zoom: 10,
    });

    map.scrollZoom.disable();

    // Add marker at the restaurant location
    new mapboxgl.Marker({ color: '#d9534f' })
      .setLngLat(restaurantCoordinates)
      .addTo(map);

    // Fetch the isochrone polygon from Mapbox Isochrone API
    const fetchIsochrone = async () => {
      try {
        const response = await fetch(
          `https://api.mapbox.com/isochrone/v1/mapbox/driving/${restaurantCoordinates[0]},${restaurantCoordinates[1]}?contours_meters=11265&polygons=true&access_token=${mapboxgl.accessToken}`
        );
        const data = await response.json();

        map.addSource('isochrone', {
          type: 'geojson',
          data: data,
        });

        map.addLayer({
          id: 'isochrone-fill',
          type: 'fill',
          source: 'isochrone',
          paint: {
            'fill-color': '#FF0000',
            'fill-opacity': 0.2,
          },
        });

        map.addLayer({
          id: 'isochrone-outline',
          type: 'line',
          source: 'isochrone',
          paint: {
            'line-color': '#FF0000',
            'line-width': 2,
          },
        });
      } catch (error) {
        console.error('Error fetching isochrone data:', error);
      }
    };

    map.on('load', fetchIsochrone);

    return () => map.remove();
  }, []);

  return (
    <div className="mapbox-container">
      <div
        ref={mapRef}
        style={{
          width: '100%',
          height: '300px',
          borderRadius: '10px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          border: '1px solid #eaeaea',
        }}
      />
      <p className="text-center text-muted mt-2" style={{ fontSize: '0.9rem' }}>
        This map shows our 8-mile driving distance delivery area from the restaurant.
      </p>
    </div>
  );
};

export default MapboxIsochroneMap;
